/**
 * Get the appropriate URL for the current environment
 * Supports Vercel deployments and local development
 */
export const getURL = (): string => {
  // In production, use the site URL
  if (import.meta.env.VITE_SITE_URL) {
    let url = import.meta.env.VITE_SITE_URL;
    return url.endsWith('/') ? url.slice(0, -1) : url;
  }

  // For Vercel deployments, use the Vercel URL
  if (import.meta.env.VITE_VERCEL_URL) {
    return `https://${import.meta.env.VITE_VERCEL_URL}`
  }

  // For local development, use window.location.origin if available
  if (typeof window !== 'undefined' && window.location.origin) {
    return window.location.origin
  }

  return 'http://localhost:3000'
}

/**
 * Get the auth callback URL for redirects
 */
export const getAuthCallbackURL = (): string => {
  const baseURL = getURL()
  return `${baseURL}/auth/callback`
}

/**
 * Get the password reset URL for redirects
 */
export const getPasswordResetURL = (): string => {
  const baseURL = getURL()
  return `${baseURL}/auth/reset-password`
}
